var ua = navigator.userAgent.toLowerCase();
var isWebView = ua.includes("wv");
var isApple = (ua.includes("ios") || ua.includes("iphone"));
var isAndroid = ua.includes("android") && ua.includes("chrome");

var hasLoaded = false;

function setCookie(name, value, expireInDays) {
    var d = new Date();
    d.setTime(d.getTime() + expireInDays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
}

function shouldLoadDeeplinkBanner() {
    const cookie = getCookie("hideDeeplinkBanner");
    if (cookie) {
        return hasLoaded == false && cookie !== "true";
    }
    return (isAndroid || isApple) && hasLoaded == false;
}

function generateDeeplinkBanner() {
    hasLoaded = true;
    if (isAndroid || isApple) {
        document.head.insertAdjacentHTML(
            "afterbegin",
            '<link rel="stylesheet" href="'+assetUrls.stylesheet+'">'
        );
        document.body.insertAdjacentHTML(
            "afterbegin",
            `<div class="venn-deeplink-banner" id="venn-deeplink-banner" style="height: 0em;">
                <div class="venn-left-content" id="venn-left-content">
                    <div class="venn-left-content-div">
                        <div class="venn-left-content-logo-container">
                            <img class="venn-app-icon" src="" id="venn-app-icon">
                        </div>
                        <div class="venn-left-content-text">
                            <h3 id="venn-app-title">Cole Buxton</h3>
                            <br>
                            <p id="venn-app-subtitle">Download our app</p>
                        </div>
                    </div>
                </div>
                <div class="venn-right-content" id="venn-right-content">
                    <div class="venn-right-content-div">
                        ${isAndroid ? `<img alt="google download" class="venn-play-store" src="https://cdn.shopify.com/s/files/1/0055/1023/4230/files/google-download_d8218266-83bd-4b9d-8c84-639277b41b75.png?v=1747298883&width=100" width="100" height:"31" title="Play Store" id="venn-store-banner">` : ``}
                        ${isApple ? `<img alt="ios download" src="https://cdn.shopify.com/s/files/1/0055/1023/4230/files/ios-download.png?v=1747298883&width=100" width="100" height:"31" title="App Store" id="venn-store-banner">` : ``}
                    </div>
                </div>
                <div class="venn-close-button"><svg id="venn-close-button"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  focusable="false"
  class="icon icon-close"
  fill="none"
  viewBox="0 0 18 17"
>
  <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
</svg></div>
            </div>`
        );
    }
}

function handleBannerClick(target) {
    if (
        target !== "venn-deeplink-banner" &&
        target !== "venn-app-icon" &&
        target !== "venn-app-title" &&
        target !== "venn-app-subtitle" &&
        target !== "venn-store-banner"
    ) {
        return;
    }

    var targetUrl;

    if (isAndroid) {
        targetUrl = "https://play.google.com/store/apps/details?id=com.vennapps.colebuxton";
    } else if (isApple) {
        targetUrl = "https://apps.apple.com/gb/app/cole-buxton/id6497794109";
    }

    window.open(targetUrl, "_self");
}

function loadDeeplinkBannerContent() {
    try {
        if (shouldLoadDeeplinkBanner()) {
            generateDeeplinkBanner();
            var banner = document.getElementById("venn-deeplink-banner");
            banner.addEventListener("click", (event) => {
                handleBannerClick(event.target.id);
            });
            var closeBtn = document.getElementById("venn-close-button");
            closeBtn.addEventListener("click", (event) => {
                hideDeeplinkBanner(event.target.id);
            });
        }
    } catch (error) {
        console.error(`There was an error obtaining deeplink content:`, error);
    }
}

function hideDeeplinkBanner(target) {
    if (target !== "venn-close-button") {
        return;
    }
    var x = document.getElementById("venn-deeplink-banner");
    x.style.display = "none";
    setCookie("hideDeeplinkBanner", "true", 1);
}

window.onload = function () {
    loadDeeplinkBannerContent();
};
